import { faCloudUpload, faTrashAlt } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, IconButton, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import theme from "css/theme/light"
import { useEffect, useMemo, useState } from "react"
import { useDropzone } from "react-dropzone"
import { useTranslation } from "react-i18next"

const StyledLabel = styled(Typography)(({ theme }) => ({
  color: "rgba(0, 0, 0, 0.54)",
  top: "-11px",
  left: "9px",
  padding: "0 5px",
  background: theme.palette.background.paper,
  position: "absolute"
}))

const StyledThumbnails = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  margin: "8px 0",
  padding: 15
}))

const StyledImg = styled("img")(({ theme }) => ({
  display: "block",
  maxWidth: "100%",
  height: "auto"
}))

const StyledDeleteButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  bottom: 0,
  right: 0
}))

const StyledBox = styled(Box)(({ theme }) => ({
  position: "relative",
  borderWidth: 2,
  borderColor: theme.palette.secondary.main,
  borderStyle: "dashed"
}))

const baseStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "24px",
  backgroundColor: theme.palette.grey[100],
  color: theme.palette.secondary.main,
  outline: "none",
  transition: "background .24s ease-in-out",
  cursor: "pointer",
  margin: "0px",
  borderRadius: 12,
  textAlign: "center"
}

const activeStyle = {
  backgroundColor: "rgba(233,233,233, 1)"
}

const acceptStyle = {
  backgroundColor: "rgba(233,233,233, 1)"
}

const rejectStyle = {
  borderColor: theme.palette.error.main
}

const FilePicker = ({
  setFieldValue,
  fieldName,
  defaultPreviewImage,
  setFile,
  fileUploadResult,
  onLogoChanged,
  label
}) => {
  const [previewFile, setPreviewFile] = useState()
  const { t } = useTranslation()
  const { getRootProps, getInputProps, isDragActive, isDragAccept, isDragReject } = useDropzone({
    accept: "image/*",
    multiple: false,
    paramName: () => "file",
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0]
      setFile(file)
      onLogoChanged({ preview: URL.createObjectURL(file), name: file.name })
      setPreviewFile({ preview: URL.createObjectURL(file), name: file.name })
    }
  })
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject, isDragAccept]
  )

  const removeFile = () => () => {
    setFile(null)
    setPreviewFile(null)
    setFieldValue(fieldName, null)
  }

  useEffect(() => {
    if (defaultPreviewImage) {
      setPreviewFile({
        preview: defaultPreviewImage,
        name: defaultPreviewImage
      })
    }
  }, [defaultPreviewImage, setFile])

  useEffect(() => {
    if (fileUploadResult?.data && fileUploadResult?.data.name) {
      setFieldValue(fieldName, fileUploadResult.data.name)
    }
  }, [fileUploadResult])

  return (
    <StyledBox border={1} borderColor="secondary.600" borderRadius="12px">
      {/* <StyledLabel variant="caption">{label}</StyledLabel> */}
      <Box spacing={3}>
        {!previewFile && (
          <div {...getRootProps({ style })}>
            <input {...getInputProps()} />
            <FontAwesomeIcon icon={faCloudUpload} size="3x" />
            <Typography mt={1.5} variant="bodySmall">
              {t("global.drop_here_or_click_to_select_files", "Drop or click here to select files")}
            </Typography>
          </div>
        )}
        {previewFile && previewFile.preview && (
          <StyledThumbnails>
            <StyledImg src={previewFile.preview} alt="" />
            <StyledDeleteButton type="button" aria-label="Ta bort" onClick={removeFile()} size="large">
              <FontAwesomeIcon icon={faTrashAlt} size="xs" />
            </StyledDeleteButton>
          </StyledThumbnails>
        )}
      </Box>
    </StyledBox>
  )
}
export default FilePicker
